export const GRAPH_CMS_API: string = process.env.REACT_APP_GRAPH_CMS_API ? process.env.REACT_APP_GRAPH_CMS_API : '';
